
<app-loadingdiv #loadingDivComponent></app-loadingdiv>
<!-- background-color: #e9f3fc; -->
<app-webcamaccessnotificationdiv #webcamAccessNotificationDivComponent></app-webcamaccessnotificationdiv>

<app-examiframe #examIframeComponent></app-examiframe>
<app-second-view-iframe #secondViewIframeComponent></app-second-view-iframe>

<div class="enter">
    <button class="action-btn" [class.loading]="proctorStartClicked" [disabled]="proctorStartClicked" (click)="loadExamIframe(true)" *ngIf="(isUsingExternalExamUrl && !proctorStarted)">Enter</button>
</div>

<button (click)="quitseb()" id="quit-btn" title="Quit SEB" *ngIf="showQuitButton">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" stroke-width="1.5" stroke="currentColor">
        <path d="M7.5 1v7h1V1h-1z" stroke-width="1.5"/>
        <path d="M3 8.812a4.999 4.999 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812z" stroke-width="1.5"/>
    </svg>
    EXIT
</button>